import { useReduxState } from 'hooks';
import { UserAttributesConditionsManager } from 'components/admin/settings/userAttributes';
import { Checkbox, FormGroup, RadioGroup } from 'components/common/form';
import { SiteSettingsForm } from '.';
import { ProfileAuthTwoFactor } from 'components/profile';

const SiteSettingsTwoFactorAuth = () => {
  const {
    messages,
    serverConfig: {
      authRequireTwoFactor,
      authRequireTwoFactorConditions,
      authSharedTwoFactor,
      userCustomAttributes
    },
    user
  } = useReduxState();

  const isVuoadmin = user?.roles.includes('vuoadmin');

  const initialValues = {
    authRequireTwoFactor,
    authRequireTwoFactorConditions,
    authSharedTwoFactor
  };

  const availableAttributes = userCustomAttributes.reduce(
    (availableAttributes, attribute) => {
      availableAttributes[attribute.key] = attribute;
      return availableAttributes;
    },
    {}
  );

  /**
   * Ensure conditions arrays are always present in the form values.
   * This is needed because informed's ArrayField drops empty arrays from the form state.
   */
  const updateValuesBeforeSubmit = (values) => {
    return {
      ...values,
      authRequireTwoFactorConditions: {
        ...values.authRequireTwoFactorConditions,
        conditions: values.authRequireTwoFactorConditions?.conditions || []
      },
      authSharedTwoFactor: {
        ...values.authSharedTwoFactor,
        conditions: values.authSharedTwoFactor?.conditions || []
      }
    };
  };

  return (
    <>
      <SiteSettingsForm
        initialValues={initialValues}
        title={messages.authTwoFactorAuthentication}
        updateValuesBeforeSubmit={updateValuesBeforeSubmit}
      >
        {(formState) => (
          <div>
            {isVuoadmin ? (
              <FormGroup
                label="Require two factor authentication"
                maxWidth="fit-content"
                style={{ marginBottom: 20 }}
              >
                <RadioGroup
                  field="authRequireTwoFactor"
                  options={[
                    {
                      id: 'auth-require-two-factor-none',
                      label: messages.siteSettingsAuthRequireTwoFactorNone,
                      value: 'none'
                    },
                    {
                      id: 'auth-require-two-factor-admins',
                      label: messages.siteSettingsAuthRequireTwoFactorAdmins,
                      value: 'admins'
                    },
                    {
                      id: 'auth-require-two-factor-all',
                      label: messages.siteSettingsAuthRequireTwoFactorAll,
                      value: 'all'
                    }
                  ]}
                />

                <UserAttributesConditionsManager
                  availableAttributes={availableAttributes}
                  disabled={formState.values.authRequireTwoFactor === 'none'}
                  fieldPrefix="authRequireTwoFactorConditions"
                  includeEmailDomainCondition={true}
                  includeIsSelfRegisteredCondition={true}
                  label={messages.authRequireTwoFactorConditionsLabel}
                  labelHelpText={
                    messages.authRequireTwoFactorConditionsLabelHelpText
                  }
                />
              </FormGroup>
            ) : null}

            <FormGroup
              label={messages.authTwoFactorAuthenticationShared}
              maxWidth="fit-content"
            >
              <Checkbox
                disabled={!isVuoadmin}
                field="authSharedTwoFactor.isEnabled"
                id="auth-shared-two-factor-enabled"
                label="Enable shared two factor authentication"
                style={{ marginBottom: 15 }}
              />

              <UserAttributesConditionsManager
                availableAttributes={availableAttributes}
                disabled={!formState.values.authSharedTwoFactor?.isEnabled}
                fieldPrefix="authSharedTwoFactor"
                includeEmailDomainCondition={true}
                includeIsSelfRegisteredCondition={true}
                label={messages.authTwoFactorSharedConditionsLabel}
                labelHelpText={
                  messages.authTwoFactorSharedConditionsLabelHelpText
                }
              />
            </FormGroup>
          </div>
        )}
      </SiteSettingsForm>

      {!isVuoadmin ? (
        <div style={{ marginTop: 20 }}>
          <ProfileAuthTwoFactor
            isSharedConfiguration={true}
            title={messages.authTwoFactorSharedActivationTitle}
          />
        </div>
      ) : null}
    </>
  );
};

export default SiteSettingsTwoFactorAuth;
